import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { EmailErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/email-error-svg/email-error-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, EmailErrorSvgComponent, MapfreButtonComponent],
  selector: 'app-billing-comment-unsuccessful',
  templateUrl: './billing-comment-unsuccessful.component.html',
})
export class BillingCommentUnsuccessfulComponent implements OnInit {
  @Input() policysource;
  @Output() tryagain: EventEmitter<boolean> = new EventEmitter();
  @Output() hideModalOutput: EventEmitter<boolean> = new EventEmitter();
  billingCommentUnsuccessfulModal: ModalOptions;
  hideModal: boolean;
  isAcmic = false;

  constructor(private acmicService: AcmicService) {
    this.billingCommentUnsuccessfulModal = new ModalOptions({
      additionalClasses:
        'modal-medium modal-dialog center-on-page modal-dialog-scrollable',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'billingCommentUnsuccessfulModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalName: 'billing_Comment_Unsuccessful',
    });
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
    this.hideModalOutput.emit(this.hideModal);
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }
  onReloadForm() {
    this.tryagain.emit(true);
  }
  onClickBack() {
    this.hideModal = !this.hideModal;
    this.hideModalOutput.emit(this.hideModal);
  }
}
